/*******************************************************************************
BUILD A MODAL WINDOW SHELL
This is essentially an empty shell to put content inside.
*******************************************************************************/

export default function buildModalWindowShell(options) {

    // All the different options that can be passed in
    const title = options.title || '';
    const content = options.content || 'This modal window needs some content';
    const isWide = (options.wide === undefined) ? false : options.wide;
    const isFull = (options.fullWidth === undefined) ? false : options.fullWidth;
    //const modalType = options.modalType || 'basic';
    const includeBackground = (options.includeBackground === undefined) ? true : options.includeBackground;
    const includeHeader = (options.includeHeader === undefined) ? true : options.includeHeader;

    // Default modal classes (for basic modal)
    const modalClasses = {
        main : 'modal',
        head : 'modal__head',
        close: 'modal__close',
    };

    const modalHeader = (!includeHeader) ? '' : `
        <div class="${modalClasses.head}">
            ${title}
            <div class="${modalClasses.close} close-modal">&times;</div>
        </div>`;

    const modalHTML = `
    <div class="${modalClasses.main}${(isWide) ? ' is-wide' : ''}${(isFull) ? ' is-full' : ''}">
        ${modalHeader}
        ${content}
    </div>`;

    return (includeBackground) ? `<div class="modal-background">${modalHTML}</div>` : modalHTML;
}
